import { Outlet } from 'react-router-dom'
import FashionHeader from './components/FashionHeader'
import FashionFooter from './components/FashionFooter'

function FashionLayout() {
  return (
    <div className="min-h-screen bg-[#f8f7f6] text-[#181211] font-[Manrope] overflow-x-hidden antialiased">
      <FashionHeader />
      <Outlet />
      <FashionFooter />
    </div>
  )
}

export default FashionLayout

